export const ROUTE_PATH = {
    home : "/",
}